import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import BalanceCheckoutPage from "@/pages/BalanceCheckoutPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminLogin from "@/pages/AdminLogin";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import "@/styles/landing.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/balance" element={<BalanceCheckoutPage />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={(
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              )}
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
